// @ts-nocheck
import constants from "@store/constants";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import SideMenu from "@store/Library/Components/Toolkit/SideMenu";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import React, { FC } from "react";
import { css } from "styled-components";

export interface MyAccountSideMenuStyles {
    wrapper?: InjectableCss;
}

export const myAccountSideMenuStyles: MyAccountSideMenuStyles = {
    wrapper: {
        css: css`
            ${spacingStyles()}
            width: 100%;
        `,
    },
};

const styles = myAccountSideMenuStyles;

const MyAccountSideMenu: FC<WidgetProps> = () => {
    return (
        <StyledWrapper {...styles.wrapper}>
            <SideMenu pageType={constants.pageType.myAccount} showRootPage showSignOut />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: MyAccountSideMenu,
    definition: {
        group: "My Account",
        icon: "NavigationList",
        displayName: "Account Menu",
    },
};

export default widgetModule;
